import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";
import { setPreviousPath } from 'redux/modules/app';
import { isLoaded as isAuthLoaded, load as loadAuth, loadPasswordReset as loadReset, forceResetState, logout } from 'redux/modules/auth';
import { setBackUrl as setAdBackUrl } from 'redux/modules/adBuilder';
import { setBackUrl as setComposeBackUrl } from 'redux/modules/composebox';
import { getContractData } from 'redux/modules/contract';
import { getFavorites } from 'redux/modules/contentLibrary';
import { setCurrentOrganization, saveOrgState } from 'redux/modules/organization';
import { loadCommissionsAccount, getOrgOwnerUser } from 'redux/modules/billing';
import restoreOrgState from 'redux/restoreOrgState';
import { loadFacebookAdAccount } from 'redux/modules/ads';
import { loadTheme } from 'redux/modules/theme';
import { loadStripeConfig, loadTimezone, loadUserType, loadWhitelabel, loadAppEnv } from 'redux/modules/config';
import { getInvite, getPartnerDetailsByPartnerOrgId } from 'redux/modules/teamManagement';
import { getSocialAccounts, fetchOrganization } from 'redux/modules/organization';
import { createQueuesForOrganizationSocialAccounts } from 'redux/modules/contentLibrary';
import { validateApprovalToken } from 'redux/modules/draftPosts';
import cookie from 'js-cookie';
import { reset } from 'redux-form';
import queryString from 'query-string';
import moment from 'moment';
import { finalizeTeamMemberCreation } from 'redux/modules/teamManagement';

var RouterMiddleware = function RouterMiddleware(store) {
  var _this = this;

  _classCallCheck(this, RouterMiddleware);

  _defineProperty(this, "handleEnterWhitelabelSettings", function (nextState, replace, cb) {
    _this.loadAuthIfNeeded(function () {
      var _this$store$getState = _this.store.getState(),
          user = _this$store$getState.auth.user;

      if (!user) {
        replace('/');
      } else if (user && !user.isPartnerOwner && !user.isPartner && !user.isLikeableLocal) {
        replace('/');
      }

      cb();
    })["catch"](function (err) {
      console.error(err);
      cb();
    });
  });

  _defineProperty(this, "requireDraftApprovalToken", /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(nextState, replace, cb) {
      var postHash;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              postHash = nextState.params.postHash;
              _context.prev = 1;
              console.log('postHash is', postHash);
              _context.next = 5;
              return _this.store.dispatch(validateApprovalToken(postHash));

            case 5:
              _context.next = 11;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](1);
              console.error(_context.t0);
              replace('/');

            case 11:
              cb();

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 7]]);
    }));

    return function (_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }());

  _defineProperty(this, "reportPdfRenderMiddleware", function (nextState, replace, cb) {
    var _nextState$location$q = nextState.location.query,
        rid = _nextState$location$q.rid,
        t = _nextState$location$q.t;

    if (!rid || !t) {
      replace('/');
      return cb();
    }

    cb();
  });

  _defineProperty(this, "loadAuthIfNeeded", function (cb) {
    var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var _this$store$getState2 = _this.store.getState(),
        _this$store$getState3 = _this$store$getState2.auth,
        user = _this$store$getState3.user,
        userLoadedAt = _this$store$getState3.userLoadedAt;

    return _this.store.dispatch(loadAuth()).then(function () {
      return cb();
    });
  });

  _defineProperty(this, "forceRefreshUser", function (nextState, replace, cb) {
    _this.loadAuthIfNeeded(function () {
      cb();
    }, true);
  });

  _defineProperty(this, "failedToLoadAuthHandler", function (err, replace, cb) {
    console.error('Failed to load auth');
    console.error(err);
    replace('/logout');
    cb();
  });

  _defineProperty(this, "requireNotLogged", function (nextState, replace, cb) {
    _this.loadAuthIfNeeded(function () {
      var _this$store$getState4 = _this.store.getState(),
          user = _this$store$getState4.auth.user;

      if (user) {
        replace("/org/".concat(user.Organizations[0].id, "/publishing"));
      }

      cb();
    })["catch"](function (err) {
      console.error(err);
      cb();
    });
  });

  _defineProperty(this, "requireLikeableLocalUser", function (nextState, replace, cb) {
    _this.loadAuthIfNeeded(function () {
      var _this$store$getState5 = _this.store.getState(),
          user = _this$store$getState5.auth.user,
          theme = _this$store$getState5.theme;

      if (user && user.isLikeableLocal) {
        if (!theme || parseInt(theme.org) !== 0) {
          replace('/');
        }

        return cb();
      }

      replace('/');
      cb();
    })["catch"](function (err) {
      return _this.failedToLoadAuthHandler(err, replace, cb);
    });
  });

  _defineProperty(this, "requireLikeableLocalUserRole", function (nextState, replace, cb) {
    _this.loadAuthIfNeeded(function () {
      var _this$store$getState6 = _this.store.getState(),
          user = _this$store$getState6.auth.user,
          theme = _this$store$getState6.theme;

      if (user && user.Roles && user.Roles.length && user.Roles.some(function (role) {
        return role.id === 1;
      })) {
        return cb();
      }

      replace('/');
      cb();
    })["catch"](function (err) {
      return _this.failedToLoadAuthHandler(err, replace, cb);
    });
  });

  _defineProperty(this, "requireNotLoggedForAgreements", function (nextState, replace, cb) {
    _this.loadAuthIfNeeded(function () {
      var _this$store$getState7 = _this.store.getState(),
          user = _this$store$getState7.auth.user;

      console.log('location', window.location);
      var signingToken = null;

      if (window.location.search) {
        var params = queryString.parse(window.location.search);

        if (params.t) {
          signingToken = params.t;
        }
      }

      var redirUrl = "/global/agreements/".concat(nextState.params.contractUuid, "/teamview");

      if (user && !signingToken) {
        replace(redirUrl);
        cb();
      } else {
        return _this.store.dispatch(getContractData(nextState.params.contractUuid, signingToken)).then(function (response) {
          if (response.data === null) {
            replace('/');
          }

          cb();
        });
      }
    })["catch"](function (err) {
      return _this.store.dispatch(getContractData(nextState.params.contractUuid)).then(function (response) {
        if (response.data === null) {
          replace('/');
        }

        cb();
      })["catch"](function (e) {
        return _this.failedToLoadAuthHandler(e, replace, cb);
      });
    });
  });

  _defineProperty(this, "requireLogin", function (nextState, replace, cb) {
    _this.loadAuthIfNeeded(function () {
      var _this$store$getState8 = _this.store.getState(),
          user = _this$store$getState8.auth.user;

      if (!user) {
        replace('/login');
      }

      cb();
    })["catch"](function (err) {
      return _this.failedToLoadAuthHandler(err, replace, cb);
    });
  });

  _defineProperty(this, "redirectToOrganization", function (nextState, replace, cb) {
    _this.requireLogin(nextState, replace, function () {
      var _this$store$getState9 = _this.store.getState(),
          user = _this$store$getState9.auth.user,
          organization = _this$store$getState9.organization;

      if (user) {
        var orgId = organization.current.id || user.Organizations[0].id; // TODO: Update with logic to forward to a selected and/or most recent org

        replace("/org/".concat(orgId, "/publishing"));
      } else {
        replace('/login');
      }

      cb();
    });
  });

  _defineProperty(this, "clearStateAndLogout", function (nextState, replace, cb) {
    _this.store.dispatch(logout());
  });

  _defineProperty(this, "requireContract", function (nextState, replace, cb) {
    _this.store.dispatch(getContractData(nextState.params.contractUuid)).then(function (response) {
      if (response.data === null) {
        replace('/');
      }

      console.log(response);
      cb();
    })["catch"](function (err) {
      console.error(err);
      replace('/');
      cb();
    });
  });

  _defineProperty(this, "contractBillingPageOnEnter", function (nextState, replace, cb) {
    _this.store.dispatch(getContractData(nextState.params.contractUuid)).then(function (response) {
      if (response.data === null || response.data && "".concat(response.data.paymentDetailEntryType) !== '1' || response.data && response.data.BillingAccountSubscription && response.data.BillingAccountSubscription.subscriptionId) {
        replace('/');
      }

      console.log(response);
      cb();
    })["catch"](function (err) {
      console.error(err);
      replace('/');
      cb();
    });
  });

  _defineProperty(this, "setOrganization", function (nextState, replace, cb) {
    var state = _this.store.getState();

    var availableOrganizations = [].concat(_toConsumableArray(state.auth.user.Organizations), _toConsumableArray(state.organization && state.organization.selectedOrganizations ? state.organization.selectedOrganizations : []));
    var currentOrganization = availableOrganizations.find(function (org) {
      return org.id === nextState.params.organizationId;
    }) || null;

    if (currentOrganization && currentOrganization.paidToDate && moment().diff(moment(currentOrganization.paidToDate), 'days') > 20) {
      // cancelled customer
      var validOrg = availableOrganizations.find(function (org) {
        return org && (!org.paidToDate || org.paidToDate && moment().diff(moment(org.paidToDate), 'days') < 20);
      });

      if (validOrg) {
        replace("/org/".concat(validOrg.id, "/publishing"));
      } else {
        console.log('NO VALID ORG', availableOrganizations);
        replace('/logout');
      }

      cb();
    }

    var orgWithState = state.organization && state.organization.selectedOrganizations ? state.organization.selectedOrganizations.find(function (org) {
      return org.id === nextState.params.organizationId;
    }) : {};

    if (currentOrganization === null) {
      console.log('CURRENT ORG IS NULL - FETCH');

      _this.store.dispatch(fetchOrganization(nextState.params.organizationId)).then(function (_ref2) {
        var remoteOrg = _ref2.data;

        if (!remoteOrg) {
          replace('/login');
          return cb();
        }

        _this.store.dispatch(setCurrentOrganization(remoteOrg));

        restoreOrgState(_this.store, {});
        cb();
      })["catch"](function (err) {
        console.error(err);
        window.location.href = '/logout';
      });
    } else {
      _this.store.dispatch(fetchOrganization(currentOrganization.id)).then(function (_ref3) {
        var remoteOrg = _ref3.data;

        var savedState = _objectSpread({}, orgWithState && orgWithState.savedState ? orgWithState.savedState : {});

        _this.store.dispatch(setCurrentOrganization(remoteOrg));

        restoreOrgState(_this.store, savedState);
        cb();
      })["catch"](function (err) {
        console.error(err);

        if (err && err.error && err.error.message.indexOf('User has no UserOrganizations') !== -1) {
          console.log('User has no user orgs');
          window.location.href = '/logout';
        }
      });
    }
  });

  _defineProperty(this, "loadPasswordReset", function (nextState, replace, cb) {
    var query = nextState.location.query;

    _this.store.dispatch(loadReset(query.c)).then(function (response) {
      if (!response.data) {
        replace('/login');
      }

      cb();
    })["catch"](function () {
      replace('/login');
      cb();
    });
  });

  _defineProperty(this, "handleOrgEnter", function (nextState, replace, cb) {
    setOrganization(nextState, replace);
  });

  _defineProperty(this, "addThemeToState", function (nextState, replace, cb) {
    var _this$store$getState10 = _this.store.getState(),
        org = _this$store$getState10.theme.org;

    return _this.store.dispatch(loadTheme(org)).then(function () {
      return cb();
    });
  });

  _defineProperty(this, "onEnterApp", function (nextState, replace, cb) {
    Promise.all([_this.onEnterLoadTheme(), _this.onEnterLoadStripeConfig(), _this.onEnterLoadUserType(), _this.onEnterLoadAppEnv()])["catch"](function (err) {
      console.error(err);
    });
    cb();
  });

  _defineProperty(this, "onEnterLoadTheme", function () {
    var _this$store$getState11 = _this.store.getState(),
        org = _this$store$getState11.theme.org;

    return _this.store.dispatch(loadTheme(org))["catch"](function () {
      return Promise.resolve();
    });
  });

  _defineProperty(this, "onEnterLoadStripeConfig", function () {
    return _this.store.dispatch(loadStripeConfig())["catch"](function () {
      return Promise.resolve();
    });
  });

  _defineProperty(this, "onEnterLoadUserType", function () {
    var _this$store$getState12 = _this.store.getState(),
        user = _this$store$getState12.auth.user;

    return user ? _this.store.dispatch(loadUserType())["catch"](function () {
      return Promise.resolve();
    }) : Promise.resolve();
  });

  _defineProperty(this, "onEnterLoadAppEnv", function () {
    var _this$store$getState13 = _this.store.getState(),
        config = _this$store$getState13.config;

    if (config.version && config.version === 2) {
      return _this.store.dispatch(loadAppEnv())["catch"](function () {
        return Promise.resolve();
      });
    }

    _this.store.dispatch(forceResetState());
  });

  _defineProperty(this, "requireNewUserInvite", function (nextState, replace, cb) {
    var query = queryString.parse(nextState.location.search);

    if (!query.u) {
      replace('/');
      cb();
    } else {
      return _this.store.dispatch(getInvite(query.u)).then(function (_ref4) {
        var data = _ref4.data;

        if (data && data[2] && data[2] > 1) {
          // This user has already setup their account via another method - skip
          return _this.store.dispatch(finalizeTeamMemberCreation({}, data[1].organization.id)).then(function (response) {
            replace('/');
            cb();
          });
        }

        cb();
      })["catch"](function (err) {
        console.error(err);
        replace('/');
        cb();
      });
    }
  });

  _defineProperty(this, "adStepOnEnter", function (nextState, replace, cb) {
    var _nextState$params = nextState.params,
        organizationId = _nextState$params.organizationId,
        step = _nextState$params.step;

    var state = _this.store.getState();

    if (state.organization.organizationTypeId === 3 && !state.auth.user.isPartner && parseInt(step) !== 1) {
      console.log('navigate to create ad step 1 because this user does not have access to the ad builder');
      replace("/org/".concat(organizationId, "/create-ad/1"));
      return cb();
    }

    if (!state.ads.adAccount || !state.ads.adAccount[organizationId]) {
      _this.store.dispatch(loadFacebookAdAccount(organizationId)).then(function () {
        _this.setLocation(state, nextState, step);

        return cb();
      });
    } else {
      _this.setLocation(state, nextState, step);

      return cb();
    }
  });

  _defineProperty(this, "setLocation", function (state, nextState, step) {
    var orgId = nextState.params.organizationId;
    var formName = "".concat(orgId);
    var prevPath = state.app.previousPath;

    _this.store.dispatch(setAdBackUrl(prevPath, orgId));

    var adForm = state.adBuilder[formName];

    if (parseInt(step) !== 1) {
      if (!adForm) {
        replace("/org/".concat(state.organization.current.id, "/create-ad/1"));
      } else if (parseInt(step) === 3) {
        if (!adForm.adBudget) {
          replace("/org/".concat(state.organization.current.id, "/create-ad/2"));
        }
      }
    } else if (parseInt(step) === 2) {
      if (!adForm) {
        console.log('navigate to create ad step 1 because this user does not have an adform created');
        replace("/org/".concat(state.organization.current.id, "/create-ad/1"));
      }
    }
  });

  _defineProperty(this, "refreshFacebookAdAccount", function (nextState, replace, cb) {
    var _this$store$getState14 = _this.store.getState(),
        current = _this$store$getState14.organization.current;

    current && current.id != null ? _this.store.dispatch(loadFacebookAdAccount(current.id))["catch"](function (err) {
      console.error(err);
    }) : Promise.resolve();
    cb();
  });

  _defineProperty(this, "saveOrgPath", function (prevState) {
    var orgId = prevState.params.organizationId;

    _this.store.dispatch(saveOrgState(orgId, prevState.location.pathname, null));
  });

  _defineProperty(this, "stashOrgState", function () {
    for (var _len = arguments.length, stateTreeKeys = new Array(_len), _key = 0; _key < _len; _key++) {
      stateTreeKeys[_key] = arguments[_key];
    }

    var _this$store = _this.store,
        getState = _this$store.getState,
        dispatch = _this$store.dispatch;
    return function (prevState) {
      var orgId = prevState.params.organizationId;
      var state = getState();
      var savedState = stateTreeKeys.reduce(function (acc, key) {
        acc[key] = state[key];
        return acc;
      }, {});
      return dispatch(saveOrgState(orgId, null, savedState));
    };
  });

  _defineProperty(this, "handleChangeRoute", function (prevState) {
    _this.store.dispatch(setPreviousPath(prevState.location.pathname));
  });

  _defineProperty(this, "handleEnterComposeRoute", function (nextState) {
    var _this$store2 = _this.store,
        dispatch = _this$store2.dispatch,
        getState = _this$store2.getState;
    var prevPath = getState().app.previousPath; // Don't change the URLs for the controls if you're tabbing over from another org

    if (prevPath && prevPath.indexOf("/".concat(getState().organization.current.id, "/")) !== -1) {
      dispatch(setComposeBackUrl(prevPath, getState().organization.current.id));
    }
  });

  _defineProperty(this, "handleEnterContentRoute", function (nextState, replace, cb) {
    var _nextState$params2 = nextState.params,
        categorySlug = _nextState$params2.categorySlug,
        bucketSlug = _nextState$params2.bucketSlug,
        organizationId = _nextState$params2.organizationId;
    var _this$store3 = _this.store,
        dispatch = _this$store3.dispatch,
        getState = _this$store3.getState;

    var state = _this.store.getState();

    var isDirectory = window.location.pathname.includes('directory');
    var currentOrgId = state.organization.current.id;
    var hasFavs = state.contentLibrary && state.contentLibrary[organizationId] && !!state.contentLibrary[organizationId].length;

    if (!isDirectory && !categorySlug && !bucketSlug && !hasFavs) {
      dispatch(getFavorites(organizationId)).then(function (res) {
        if (res.data.favoriteCategories.length) {
          replace("/org/".concat(organizationId, "/content/category/").concat(res.data.favoriteCategories[0].slug));
        } else {
          replace("/org/".concat(organizationId, "/content/directory"));
        }

        return cb();
      });
    } else {
      return cb();
    }

    console.log('in handleEnterContentRoute');
    console.log(nextState.params);
  });

  _defineProperty(this, "requireOrgOwner", function (nextState, replace, cb) {
    var _this$store4 = _this.store,
        dispatch = _this$store4.dispatch,
        getState = _this$store4.getState;

    _this.loadAuthIfNeeded(function () {
      var _getState = getState(),
          current = _getState.organization.current,
          user = _getState.auth.user,
          organizationOwnerUser = _getState.billing.organizationOwnerUser;

      if (!organizationOwnerUser || organizationOwnerUser && !user.isLikeableLocal && "".concat(organizationOwnerUser.id) !== "".concat(user.id)) {
        dispatch(getOrgOwnerUser()).then(function (_ref5) {
          var orgOwner = _ref5.data;

          if (user.id !== orgOwner.id && !user.isLikeableLocal) {
            replace('/');
          }

          cb();
        })["catch"](function (err) {
          console.error(err);
          replace('/');
          cb();
        });
      } else if (organizationOwnerUser && "".concat(organizationOwnerUser.id) === "".concat(user.id) || user.isLikeableLocal) {
        cb();
      }
    })["catch"](function (err) {
      return _this.failedToLoadAuthHandler(err, replace, cb);
    });
  });

  _defineProperty(this, "requirePartnerType", function () {
    var partnerType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'normal';
    return function (nextState, replace, cb) {
      var _this$store5 = _this.store,
          dispatch = _this$store5.dispatch,
          getState = _this$store5.getState;

      var _getState2 = getState(),
          orgId = _getState2.theme.org;

      dispatch(getPartnerDetailsByPartnerOrgId(orgId)).then(function (_ref6) {
        var partnerDetails = _ref6.data;

        if (partnerType === 'normal') {
          if (partnerDetails.mlp) {
            replace('/');
            cb();
          } else {
            cb();
          }
        } else if (partnerDetails.mlp) {
          cb();
        } else {
          replace('/');
          cb();
        }
      })["catch"](function (err) {
        return _this.failedToLoadAuthHandler(err, replace, cb);
      });
    };
  });

  _defineProperty(this, "loadTimezoneData", function (nextState, replace, cb) {
    _this.store.dispatch(loadTimezone(_this.store.getState().organization.current.id)).then(function () {
      return cb();
    })["catch"](function (err) {
      console.error(err);
      cb();
    });
  });

  _defineProperty(this, "leaveSchedulePage", function (nextState, replace, cb) {
    return Promise.all([_this.stashOrgStateGeneric(nextState, replace, cb)]);
  });

  this.store = store;
  this.stashOrgStateGeneric = this.stashOrgState();
  this.stashOrgStateMessageCenter = this.stashOrgState('messageCenter');
};

export { RouterMiddleware as default };